import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { FieldStackedLabel } from '../../../Field'
import { FormFieldsContainer } from '../../../Form'
import {
  FormikEntityActionConfigFields,
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../Formik'
import { InputField } from '../../../Input'

function UserEditTextFieldFormModalFields({
  fieldInfoKey,
  fieldLabelKey,
  fieldMaxLength,
  fieldName,
  fieldPlaceholderKey,
  fieldRequired,
  typeSelectProps,
  withActionTypeSelect = true,
  withRequiredIcon = true,
}) {
  const { t } = useTranslation()

  const field = (
    <FormikField
      autoFocus
      clearable
      Component={InputField}
      Field={FieldStackedLabel}
      fieldComponentProps={{
        info: fieldInfoKey ? t(fieldInfoKey) : null,
        infoTooltipPlacement: FLOATING_ELEMENT_PLACEMENT.top,
        label: t(fieldLabelKey),
        required: fieldRequired && withRequiredIcon,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      maxLength={fieldMaxLength}
      name={fieldName}
      placeholder={t(fieldPlaceholderKey)}
    />
  )

  return (
    <FormFieldsContainer>
      {withActionTypeSelect ? (
        <FormikEntityActionConfigFields typeSelectProps={typeSelectProps}>
          {field}
        </FormikEntityActionConfigFields>
      ) : (
        field
      )}
    </FormFieldsContainer>
  )
}

export default UserEditTextFieldFormModalFields
